import { PunchEntry } from '../service/backend-service';
import moment from 'moment';
import { reportTimeFormat } from '../constants';
import { TimeUtils } from '../util/time-utils';
import PunchEdit from './punch-edit';

function PunchEntryElement({
  punchEntry,
  onSave
}: {
  punchEntry: PunchEntry,
  onSave: (newPunch: PunchEntry) => void,
}) {

  return (
    <li className="list-group-item p-0">
      <div className={"d-flex w-100 align-items-center justify-content-between pt-1 pb-1 ps-3 pe-3 alert-" + punchEntry.project.color}>
        <h5 className="mb-0 fw-bold">{punchEntry.project.name}</h5>
        <span>
          Sprint <b>{punchEntry.sprintId}</b>
          <PunchEdit extraClasses={'ms-2'} punchEntry={punchEntry} onSave={onSave}/> 
        </span>
      </div>
      <div className={"d-flex w-100 align-items-center justify-content-between ps-3 pe-3 pb-2 pt-1"}>
        <div style={{maxWidth: '80%'}} className="d-flex flex-column">
          <div className="fw-bold">{moment(punchEntry.start).format(reportTimeFormat)} - {!!!punchEntry.end ? 'Running' : moment(punchEntry.end).format(reportTimeFormat)}</div>
          {
            !!!punchEntry.workDescription ? null : <div><small>{punchEntry.workDescription}</small></div>  
          }
        </div>
        {
          !!!punchEntry.end ? null : <div style={{maxWidth: '20%'}} >{TimeUtils.timeWorked(punchEntry)}</div>
        }
      </div>
    </li>
  );
}

export default PunchEntryElement;
